import ReactDOM from "react-dom";
import React from "react";
import App from "./app.js";
import "./Index.css";

ReactDOM.render(React.createElement(App), document.getElementById("app"));
